import React from "react";
import { Box, Typography, Stack, Avatar, Divider } from "@mui/material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";

import PlaylistPlayRoundedIcon from "@mui/icons-material/PlaylistPlayRounded";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import PlaylistPlayIcon from "@mui/icons-material/PlaylistPlay";
import SortIcon from "@mui/icons-material/Sort";
import { Chat } from "react-iconly";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./index.scss";

export default function AnalyticsStats({
  music,
  view,
  tip,
  play,
  share,
  follow,
  onClick,
}) {
  const { t } = useTranslation("common");
  const history = useHistory();
  return (
    <Stack
      className="bg_change _cp p5"
      direction="row"
      alignItems="center"
      width="100%"
      onClick={() => {
        onClick(
          view
            ? "Views"
            : tip
            ? "Tips"
            : play
            ? "Streams"
            : share
            ? "Share"
            : follow
            ? "Follow"
            : "Nnull"
        );
      }}
      // onClick={(path) => history.push(`/app/LifetimeCount/${path}/${music["title"]}`)}
    >
      <Box sx={{ marginRight: "17px" }} className="one">
        <Avatar
          // sx={{ width: "60px", height: "60px" }}
          src={music["thumbnailImg"]["filePath"]}
        />
      </Box>
      <Stack
        directory="column"
        sx={{ width: "100% !important" }}
        className="two"
      >
        <Typography
          variant="body1"
          style={{ fontSize: "17px", cursor: "pointer" }}
        >
          {music["title"]}
        </Typography>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing={0.5}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              gap="5px"
            >
              <SortIcon
                className="fade-text80"
                sx={{ width: "18px !important", transform: "rotateZ(271deg)" }}
              />
              <Typography variant="body2" className="fade-text80 _cp">
                {t("analytics.music.text1")} {music["listens"]}
              </Typography>
              <Divider orientation="vertical" flexItem />
              <Typography variant="body2" className="fade-text80 _cp">
                {t("analytics.music.text2")} {music["uploadedAt"]}
              </Typography>
            </Stack>
          </Stack>
          <Stack direction="row" spacing={1}>
            {/* {music["views"] >= 0 ? (
              <Stack direction="row" spacing={0.5} alignItems="center">
                <RemoveRedEyeOutlinedIcon
                  sx={{ width: "18px !important" }}
                  className="fade-text80"
                />
                <Typography
                  className="fs-11 text-fade80"
                  style={{ width: "23px" }}
                >
                  {music["views"]}
                </Typography>
              </Stack>
            ) : null} */}
            <Stack direction="row" alignItems="center">
              <PlaylistPlayRoundedIcon className="fade-text80" />
              <Typography
                className="fs-12 text-fade80"
                style={{ width: "23px" }}
              >
                {music["listens"] ? music["listens"] : 0}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <VolunteerActivismIcon
                className="fade-text80"
                sx={{ width: "18px !important" }}
              />
              <Typography
                className="fs-12 text-fade80"
                style={{ width: "23px" }}
              >
                {music["tip"] ? music["tip"].toFixed(1) : 0}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
// export { music };
